import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Fuse from "fuse.js";

import Checkbox from 'material-ui/Checkbox';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { getUserList, addUsersFromAutocomplete } from 'actions/users';
import api from 'services';
import { findMembersOfCompany, getCompanies, findCompanyById, findCompany } from '../../../services/companies';

import styles from 'styles';
import Row from './Row';
import { AutoComplete } from 'material-ui';

class AutoCompleteWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            autocompleteSource: [],
            value: '',
            _id: undefined,
        }

        this.handleCompanySelect = this.handleCompanySelect.bind(this);
        this.handleAutocomplete = this.handleAutocomplete.bind(this);
    }


    async handleAutocomplete(value) {
        if (value.length < 2) return;

        const found = this.props.fuse.search(value);

        await this.setState(() => ({
            value: value,
            autocompleteSource: found,
        }));
      
    }

    async handleCompanySelect(selected) {
        if (!selected._id) return;
        this.setState({ _id: selected._id });

        const companyMembers = await findMembersOfCompany({ _id: selected._id });

        this.props.updateUserListWithCompanyFilter(companyMembers);
        this.props.toggleFilterByCompanies(selected._id);
    }

    render() {
        return (
            <AutoComplete 
                floatingLabelText="Search by company name"
                dataSource={this.state.autocompleteSource}
                dataSourceConfig={{text: 'name', value: '_id'}}
                onUpdateInput={this.handleAutocomplete}
                filter={AutoComplete.caseInsensitiveFilter}
                maxSearchResults={20}
                menuStyle={{maxHeight: '500px'}}
                onKeyDown={ (e) => {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        return false;
                    }
                }}
                onNewRequest={(selected, e, r) => {
                    this.handleCompanySelect(selected);
                    this.props.toggleRoleSetting(this.state.value);
                }}
            />
        );
    }
}
 
class TableUsersBan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            users: [],
            companies: [],
            companyNames: [],
            search: '',
            isDataFromAutoComplete: false,
            isFilteredByCompany: false,
            isSettingRoleEnabled: false,
        };

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.keyPress = this.keyPress.bind(this);
        this.onChange = this.onChange.bind(this);

        this.toggleCompanyRole = this.toggleCompanyRole.bind(this);
        this.toggleRoleSetting = this.toggleRoleSetting.bind(this);
        this.toggleFilterByCompanies = this.toggleFilterByCompanies.bind(this);
        this.updateCompanyMemberStatus = this.updateCompanyMemberStatus.bind(this);
        this.updateUserListWithCompanyFilter = this.updateUserListWithCompanyFilter.bind(this);
    }

    onChange(e, value) {
        this.setState({
            search: value,
        }, () => {
            if (this.state.search === '') {
                this.props.getUserList({
                   page: 1,
                });
            }
        });
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            if (this.state.search === '') return;
            
            let companyName; 
            if (this.state.isFilteredByCompany) companyName = this.state.search;

            api.findUser(this.state.search, true, companyName)
                .then((response) => {
                    this.props.addUsersFromAutocomplete(response.data);
                })
                .catch((response) => {
                    console.error(response);
                });
        }
    }

    nextPage() {
        this.props.getUserList({
            page: this.state.next,
            limit: 25,
        });
        this.setState(() => ({
            isFilteredByCompany: false,
        }));
    }

    prevPage() {
        this.props.getUserList({
            page: this.state.previous,
            limit: 25,
        });
        this.setState(() => ({
            isFilteredByCompany: false,
        }));
    }

    async componentDidMount() {
        const response = await getCompanies();
    
        this.setState(() => ({
            companies: response.data,
        }));
    }

    async updateUserListWithCompanyFilter(newUserListWithCompanyRoles) {
        this.setState(() => ({
            users: newUserListWithCompanyRoles,
        }));
    }

    async updateCompanyMemberStatus(user) {   
        const updatedUser = await api.findUserById(user);
        const updatedUsers = this.state.users.map(oldUser => {
            if (oldUser.user._id === updatedUser._id) {
                oldUser.user.approved = updatedUser.approved;
                oldUser.role = updatedUser.role;
            }
            return oldUser;
        });

        this.setState(() => ({
            users: updatedUsers,
        }));
    }

    toggleRoleSetting(autocompleteSearchStr) {
        if (autocompleteSearchStr.length < 2 || !autocompleteSearchStr.length) {
    
            this.setState(() => ({
                isSettingRoleEnabled: false,
            }));

            return;
        }

        this.setState(() => ({
            isSettingRoleEnabled: true,
        }));
    }

    async toggleCompanyRole(user) {
        if (user.role === 'owner') {
            return;
        }
        if (user.role === 'pending') {
            return;
        }

        const responseBeforeUpdate = await findCompanyById(user.company._id);

        const companyUsers = responseBeforeUpdate.participants;

        if (user.role === 'manager') {
            await companyUsers.forEach(userInCompany => {
                userInCompany.company = {_id: user.company._id};
                if (userInCompany.role !== 'pending') {
                    userInCompany.role = 'manager';
                    if (userInCompany._id === user._id) {
                        userInCompany.role = 'owner';
                    }
                }
            });
        }

        await api.setNewParticipantsRoles(companyUsers, user.company._id);
        const company = await findCompanyById(user.company._id);
        const updatedCompanyUsers = company.participants;

        await updatedCompanyUsers.forEach(newUser => {
            newUser.company = {_id: company._id, name: company.name};
            newUser.user = {};
            this.state.users.forEach(oldUser => {
                if (oldUser._id === newUser._id) {
                    newUser.user._id = oldUser.user._id;
                    newUser.user.approved =  oldUser.user.approved;
                    newUser.user.emailVerified = oldUser.user.emailVerified;
                    newUser.user.createdAt = oldUser.user.createdAt;
                }
            });
        });
        
        this.updateUserListWithCompanyFilter(updatedCompanyUsers);

    }

    toggleFilterByCompanies(searchValue) {
        if (!searchValue.length) {
            this.setState(prevState => ({
                isFilteredByCompany: false,
            }));
            return;
        }

        this.setState(prevState => ({
            isFilteredByCompany: true,
        }));
    }

    async UNSAFE_componentWillReceiveProps(nextProps) {
        await this.setState({
            users: nextProps.users.data,
            page: nextProps.users.page || 1,
            previous: nextProps.users.previous,
            next: nextProps.users.next,
            isDataFromAutoComplete: nextProps.users.isDataFromAutoComplete,
        });
    }

    render() {
        const { users, page, isDataFromAutoComplete } = this.state;

        const fuse = new Fuse(this.state.companies, {
            threshold: 0,
            location: 0,
            distance: 10,
            maxPatternLength: 10,
            minMatchCharLength: 2,
            keys: ['name'],
        });

        return (
            <div>
                <div className='row'>
                    <div className='col-xs-4 middle-xs' style={{ display: 'flex' }}>
                        <div style={{ width: '100%' }}>
                            <TextField
                                floatingLabelText='Search'
                                onChange={this.onChange}
                                onKeyDown={this.keyPress}
                                fullWidth
                            />
                        </div>
                    </div>

                    <div className='col-xs-4 middle-xs' style={{ display: 'flex' }}>
                        <AutoCompleteWrapper 
                            fuse={fuse}
                            toggleRoleSetting={this.toggleRoleSetting}
                            updateUserListWithCompanyFilter={this.updateUserListWithCompanyFilter}
                            toggleFilterByCompanies={this.toggleFilterByCompanies}
                        />
                    </div> 
                    
                    <div className='col-xs-4'>
                        <div className=' center-xs middle-xs' style={{ width: '100%', display: 'flex' }}>
                            {
                                !isDataFromAutoComplete
                                    ?
                                    <Fragment>
                                        <IconButton
                                            iconStyle={styles.navigationLeft}
                                            name='navigationLeft'
                                            onClick={this.prevPage}
                                        >
                                            <ChevronLeft />
                                        </IconButton>
                                        <span>Page: {page}</span>
                                        <IconButton
                                            iconStyle={styles.navigationRight}
                                            name='navigationRight'
                                            onClick={this.nextPage}
                                        >
                                            <ChevronRight />
                                        </IconButton>
                                    </Fragment>
                                : null
                            }
                        </div>
                    </div>
                </div>

                <div className='table-body'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Name
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableRowColumnBigCSS}>
                                    Email
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Role
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    CreatedAt
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Company name
                                </TableHeaderColumn>
                                {this.state.isSettingRoleEnabled && this.state.isFilteredByCompany ? 
                                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                        Company role
                                    </TableHeaderColumn>   :
                                    null
                                }
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Email verification status
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    User approval
                                </TableHeaderColumn> 
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS} />
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                users.map((item, index) => {
                                    return (<Row
                                        key={item.user && item.user._id ||item._id}
                                        item={item}
                                        isFilteredByCompany={this.state.isFilteredByCompany}
                                        isVerifiedEmail={this.state.users[index].emailVerified}
                                        isApproved={item.user && item.user.approved || item.approved}
                                        companyRoleMode={this.state.isSettingRoleEnabled}
                                        toggleCompanyRole={this.toggleCompanyRole}
                                        companyRole={item.role || 'unset'}
                                        updateCompanyMemberStatus={this.updateCompanyMemberStatus}
                                    />);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ users }) => {
        return {
            users,
        };
    },
    dispatch => bindActionCreators({
            getUserList,
            addUsersFromAutocomplete,
    },
    dispatch),
)(TableUsersBan);



// WEBPACK FOOTER //
// ./app/components/Users/BanList/Table.jsx